// extracted by mini-css-extract-plugin
export default {"map":"Map_map__WJrpr","mapVideo":"Map_mapVideo__wAu-6"};